export default {
  clearData (comp, full) {
    if (full) {
      comp.canSwitch = true
      comp.currentTransition = null
      comp.nextTransition = null
    }
    comp.currentAnnotationIndex = 0
    comp.currentAnnotationVideo = null
    comp.currentIndex = -1
    this.updateState(comp)
  },
  goHome (comp) {
    console.log('go home')
    if (comp.canSwitch) {
      comp.currentTransition = comp.currentState.id + 'Out'
      comp.canSwitch = false
      this.clearData(comp, false)
      this.playTransition(comp)
    }
  },
  navigateTo (comp, index) {
    var atHome = comp.atHome
    this.clearData(comp, false)
    comp.currentIndex = index
    console.log('navigateTo: ' + index)
    if (comp.currentIndex >= comp.states.length) {
      comp.currentIndex = 0
    } else if (comp.currentIndex < 0) {
      comp.currentIndex = comp.states.length - 1
    }
    this.updateState(comp)
    const prevTransition = comp.currentTransition
    if (prevTransition) {
      const trans = document.getElementById(prevTransition)
      if (trans) {
        this.resetVideo(trans, true)
      }
    }
    if (atHome || !comp.canSwitch) {
      comp.currentTransition = comp.currentState.id + 'In'
    } else {
      comp.currentTransition = comp.currentState.id + 'Out'
      comp.nextTransition = comp.currentState.id + 'In'
    }
    comp.canSwitch = false
    this.playTransition(comp)
  },
  playAnnotationBackground (playerId) {
    if (playerId) {
      console.log('playAnnotationBackground ' + playerId)
      const bgVideo = document.getElementById(playerId)
      this.resetVideo(bgVideo)
    }
  },
  playAnnotationVideo (comp) {
    if (comp.currentState.videos[comp.currentAnnotationIndex]) {
      comp.currentAnnotationVideo = comp.currentAnnotation
      const annotationVideo = document.getElementById(comp.currentAnnotation + 'AnnotationVideo')
      this.resetVideo(annotationVideo)
    } else {
      comp.currentAnnotationVideo = null
    }
  },
  playTransition (comp) {
    const trans = comp.currentTransition
    if (trans) {
      console.log('playTransition ' + trans)
      const transVideo = document.getElementById(trans)
      if (transVideo) {
        this.resetVideo(transVideo)
      } else {
        this.transitionEnded(comp)
      }
    }
  },
  resetScene (comp) {
    console.log('resetScene')
    this.clearData(comp, true)
    comp.$emit('did-reset')
  },
  resetVideo (video, pause) {
    if (video) {
      video.style.visibility = 'hidden'
      // video.pause()
      video.currentTime = 0
      const playListener = function () {
        video.style.visibility = 'visible'
        video.removeEventListener('playing', playListener)
      }
      video.addEventListener('playing', playListener)
      if (!pause) {
        video.play()
      }
    }
  },
  switchAnnotation (comp, index) {
    console.log('switching annotation to index ' + index)
    comp.currentAnnotationIndex = index
    comp.currentAnnotation = comp.currentState.id + 'Annotation' + index
    comp.$emit('switch-annotation', comp.currentAnnotation)
    this.playAnnotationVideo(comp)
  },
  transitionEnded (comp) {
    const trans = comp.currentTransition
    console.log('transition ended ' + trans)
    if (comp.atHome === true) {
      comp.currentAnnotation = null
      comp.currentAnnotationIndex = -1
    }
    const video = document.getElementById(trans)
    if (video && !trans.endsWith('In')) {
      video.style.visibility = 'hidden'
      const section = this
      comp.$nextTick(function () {
        section.resetVideo(video, true)
      })
    }
    if (trans.endsWith('Out')) {
      const inVideo = document.getElementById(comp.currentState)
      if (inVideo) {
        this.resetVideo(inVideo, true)
      }
    }
    if (comp.nextTransition === null) {
      comp.canSwitch = true
      if (comp.currentIndex > -1) {
        const nextAnnotationIndex = comp.multiStep ? ++comp.currentAnnotationIndex : 0
        this.switchAnnotation(comp, nextAnnotationIndex)
      }
    } else {
      comp.currentTransition = comp.nextTransition
      comp.nextTransition = null
      this.playTransition(comp)
    }
  },
  updateSegmentText (comp, text) {
    comp.$emit('update-segment-text', text)
  },
  updateState (comp) {
    if (comp.currentIndex === -1) {
      comp.currentState = null
      this.updateSegmentText(comp, null)
    } else {
      comp.currentState = comp.states[comp.currentIndex]
      this.updateSegmentText(comp, comp.currentState.title)
    }
  }
}
